import { createAsyncThunk } from '@reduxjs/toolkit'

import Axios from '../axios'
import { deserialize } from '../utility/serialization'
import { handleAPIError } from '../utility/actionHelper'

const ALL_ORGANIZATIONS_PER_PAGE = 100

export const getOrganizations = createAsyncThunk(
  'organizations/getOrganizations',
  async ({ page, perPage, sortField, sortValue } = {}, { rejectWithValue }) => {
    try {
      const { data } = await requestOrganizations(page, perPage, { sortField, sortValue })
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const getAllOrganizations = createAsyncThunk(
  'organizations/getAllOrganizations',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await requestOrganizations(1, ALL_ORGANIZATIONS_PER_PAGE)
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const createOrganization = createAsyncThunk(
  'organizations/createOrganization',
  async (name, { rejectWithValue }) => {
    try {
      const { data } = await Axios.post('/api/v1/admin/organizations', { name })
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const updateOrganization = createAsyncThunk(
  'organizations/updateOrganization',
  async ({ id, name }, { rejectWithValue }) => {
    try {
      const { data } = await Axios.put(`/api/v1/admin/organizations/${id}`, { name })
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const deleteOrganization = createAsyncThunk(
  'organizations/deleteOrganization',
  async (id, { rejectWithValue }) => {
    try {
      await Axios.delete(`/api/v1/admin/organizations/${id}`)
      return id
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

const requestOrganizations = (page, perPage, { sortField, sortValue } = {}) => Axios.get(
  '/api/v1/admin/organizations',
  { params: { page, per_page: perPage, sort_field: sortField || undefined, sort_value: sortValue || undefined } }
)
